import { ColDef, GridOptions } from '@ag-grid-community/core';
import { injectable } from 'inversify';

import { commonGridOptions } from '../blotter.service.utils';
import { EBlotterTab } from '../../../enums';
import { IKondorBlotterPositionService } from './kondor-blotter.interface';
import { positionBlotterColumns } from './kondor-blotter-position.utils';

@injectable()
export class KondorBlotterPositionService implements IKondorBlotterPositionService {

    type = 'position' as EBlotterTab;

    gridOptions(): GridOptions {
        return {
            ...commonGridOptions,
            suppressFieldDotNotation: true,
            rowSelection: 'single',
            rowGroupPanelShow: 'never',
            suppressAggFuncInHeader: true,
            autoGroupColumnDef: {
                pinned: 'left',
                lockPinned: true,
                minWidth: 190,
                sortable: true,
                sort: 'asc',
                headerName: 'Pair > Maturity Date',
                headerComponentParams: {
                    isCollapsible: true,
                },
                headerComponent: 'agColumnHeader',
            },
            onCellDoubleClicked: ({ api, node, column }) => {
                if (column.getColId() === 'ag-Grid-AutoColumn' || column.getUserProvidedColDef()?.editable) {
                    return;
                }
                node.expanded = !node.expanded;
                api.onGroupExpandedOrCollapsed();
            },
        };
    }

    columnDefinitions(): Array<ColDef> {
        return positionBlotterColumns();
    }
}
